import { useRouter } from "next/dist/client/router";
import { useMemo, useCallback } from "react";

type Props = {
  keys: string[];
  method?: "push" | "replace";
};

const useQueryParams = (props: Props) => {
  const { method, keys } = props;
  const { search } = window.location;

  const { push, replace } = useRouter();

  let navMethod: any;

  switch (method) {
    case "push": {
      navMethod = push;
      break;
    }
    case "replace": {
      navMethod = replace;
      break;
    }
    default: {
      navMethod = push;
    }
  }

  const query = useMemo(() => new URLSearchParams(search), [search]);

  const value = useMemo(
    () =>
      keys.reduce((acc: any, key: string) => {
        const result = query.get(key);
        acc[key] = !!result ? result : undefined;
        return acc;
      }, {}),
    [keys, query]
  );

  const setValue = useCallback(
    (values: { [k: string]: string | number }) => {
      keys.forEach((key) => {
        if (query.has(key)) {
          values[key] &&
            query.set(
              key,
              typeof values[key] === "number"
                ? `${values[key]}`
                : (values[key] as any)
            );
        } else {
          query.append(
            key,
            typeof values[key] === "number"
              ? `${values[key]}`
              : (values[key] as any)
          );
        }
        if (!values[key]) query.delete(key);
      });
      navMethod({
        search: query.toString(),
      });
    },
    [navMethod, query, keys]
  );

  return useMemo(() => [value, setValue] as const, [value, setValue]);
};

export default useQueryParams;
